import ResourceManager from "@/components/admin/ResourceManager";
import { Field, ImageUploader, Toggle } from "@/components/admin/Primitives";

export default function MatchResults() {
  return (
    <ResourceManager
      resource="match-results"
      title="Match Results"
      subtitle="Add finished match scores. They appear on Home and the Results page. Upload real team logos or leave empty for auto initials."
      defaults={{
        league: "Premier League",
        match_date: new Date().toISOString().slice(0, 16),
        team_a_name: "", team_a_logo: "", team_a_score: "",
        team_b_name: "", team_b_logo: "", team_b_score: "",
        venue: "", is_published: true,
      }}
      columns={[
        { key: "match_date", label: "Date", render: (r) => new Date(r.match_date).toLocaleDateString() },
        { key: "league", label: "League" },
        { key: "team_a_name", label: "Team A" },
        { key: "team_a_score", label: "Score", render: (r) => `${r.team_a_score} - ${r.team_b_score}` },
        { key: "team_b_name", label: "Team B" },
        { key: "is_published", label: "Published" },
      ]}
      renderForm={(form, setForm) => (
        <>
          <Field label="League" value={form.league} onChange={(v) => setForm({ ...form, league: v })} required testid="match-league" />
          <Field label="Match date" type="datetime-local" value={form.match_date?.slice(0, 16)} onChange={(v) => setForm({ ...form, match_date: v })} required testid="match-date" />
          <Field label="Venue" value={form.venue} onChange={(v) => setForm({ ...form, venue: v })} testid="match-venue" />

          <div className="pt-3 border-t border-[var(--pz-line)]">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[var(--pz-red)] mb-3">Team A</div>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Team A name" value={form.team_a_name} onChange={(v) => setForm({ ...form, team_a_name: v })} required testid="team-a-name" />
              <Field label="Team A score" value={form.team_a_score} onChange={(v) => setForm({ ...form, team_a_score: v })} required testid="team-a-score" placeholder="140" />
            </div>
            <div className="mt-3">
              <ImageUploader label="Team A logo (optional)" value={form.team_a_logo} onChange={(v) => setForm({ ...form, team_a_logo: v })} testid="team-a-logo" />
            </div>
          </div>

          <div className="pt-3 border-t border-[var(--pz-line)]">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[var(--pz-red)] mb-3">Team B</div>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Team B name" value={form.team_b_name} onChange={(v) => setForm({ ...form, team_b_name: v })} required testid="team-b-name" />
              <Field label="Team B score" value={form.team_b_score} onChange={(v) => setForm({ ...form, team_b_score: v })} required testid="team-b-score" placeholder="110" />
            </div>
            <div className="mt-3">
              <ImageUploader label="Team B logo (optional)" value={form.team_b_logo} onChange={(v) => setForm({ ...form, team_b_logo: v })} testid="team-b-logo" />
            </div>
          </div>

          <div className="pt-3 border-t border-[var(--pz-line)]">
            <Toggle label="Published" checked={form.is_published} onChange={(v) => setForm({ ...form, is_published: v })} testid="match-published" />
          </div>
        </>
      )}
    />
  );
}
